<div class="body">
    <canvas baseChart width="400" height="400" *ngIf="showChart" [datasets]="datasets" [labels]="labels"
        [options]="lineChartOptions" [legend]="lineChartLegend" [chartType]="type"
        [plugins]="lineChartPlugins">
    </canvas>
</div>